<template>
  <a-layout-sider :collapsed="isCollapsed" collapsible :trigger="null" :width="232" :collapsedWidth="64"
    class="side-sider">
    <div class="side-inner">
      <div class="side-logo" @click="navigateTo('/')">
        <img src="https://xiaochu.ljwx.site/img/logo2.png" class="logo-img"
          :class="{ collapsed: isCollapsed, hidden: logoFailed }" @error="logoFailed = true" @load="logoFailed = false">
        <span v-if="!isCollapsed && logoFailed" class="logo-text">晓风授权站</span>
      </div>
      <a-menu theme="dark" mode="inline" :inline-collapsed="isCollapsed" :selected-keys="[defaultActive]"
        :open-keys="openKeys" @update:open-keys="onOpenKeysChange" class="side-menu">
        <a-sub-menu key="1">
          <template #icon>
            <DashboardOutlined />
          </template>
          <template #title>数据中心</template>
          <a-menu-item key="/console" @click="navigateTo('/console')">控制台</a-menu-item>
          <a-menu-item key="/userLog" @click="navigateTo('/userLog')">用户日志</a-menu-item>
        </a-sub-menu>

        <a-menu-item key="/dockKey" @click="navigateTo('/dockKey')">
          <template #icon>
            <KeyOutlined />
          </template>
          <span>接口密钥</span>
        </a-menu-item>

        <a-menu-item key="/withdrawal" @click="navigateTo('/withdrawal')">
          <template #icon>
            <BankOutlined />
          </template>
          <span>提现记录</span>
        </a-menu-item>

        <a-menu-item key="/agentEmpower" @click="navigateTo('/agentEmpower')">
          <template #icon>
            <TeamOutlined />
          </template>
          <span>代理中心</span>
        </a-menu-item>

        <a-menu-item v-if="user_conf.uid == 1000" key="/userManage" @click="navigateTo('/userManage')">
          <template #icon>
            <UserOutlined />
          </template>
          <span>用户管理</span>
        </a-menu-item>

        <a-menu-item v-if="user_conf.uid == 1000" key="/withdrawalManage" @click="navigateTo('/withdrawalManage')">
          <template #icon>
            <WalletOutlined />
          </template>
          <span>提现管理</span>
        </a-menu-item>

        <a-menu-item key="/includesList" @click="navigateTo('/includesList')">
          <template #icon>
            <AppstoreOutlined />
          </template>
          <span>软件列表</span>
        </a-menu-item>

        <a-sub-menu v-if="user_conf.uid == 1000" key="6">
          <template #icon>
            <CodeOutlined />
          </template>
          <template #title>开发中心</template>
          <a-menu-item key="/develop" @click="navigateTo('/develop')">数据概览</a-menu-item>
          <a-menu-item key="/productManage" @click="navigateTo('/productManage')">产品管理</a-menu-item>
          <a-menu-item key="/VersionLog" @click="navigateTo('/VersionLog')">版本管理</a-menu-item>
          <a-menu-item key="/NoticeManage" @click="navigateTo('/NoticeManage')">公告管理</a-menu-item>
          <a-menu-item key="/DataManage" @click="navigateTo('/DataManage')">数据管理</a-menu-item>
        </a-sub-menu>

        <a-sub-menu key="7">
          <template #icon>
            <GiftOutlined />
          </template>
          <template #title>卡密管理</template>
          <a-menu-item key="/CarmineList" @click="navigateTo('/CarmineList')">卡密列表</a-menu-item>
          <a-menu-item key="/CarmineUse" @click="navigateTo('/CarmineUse')">使用卡密</a-menu-item>
        </a-sub-menu>

        <a-menu-item key="/freeBenefits" @click="navigateTo('/freeBenefits')">
          <template #icon>
            <ThunderboltOutlined />
          </template>
          <span>免费授权</span>
        </a-menu-item>

        <a-menu-item key="/query" @click="navigateTo('/query')">
          <template #icon>
            <SearchOutlined />
          </template>
          <span>授权查询</span>
        </a-menu-item>

        <a-menu-divider />

        <a-menu-item key="logout" @click="openDialog('消息', '您确认要退出登录吗', true, 'outLogin')">
          <template #icon>
            <LogoutOutlined />
          </template>
          <span>退出登录</span>
        </a-menu-item>
      </a-menu>

      <a-modal v-model:open="centerDialog.isShow" :title="centerDialog.title" width="420" :mask-closable="false"
        :footer="null">
        <p style="font-size: 14px; color: #595959;">{{ centerDialog.content }}</p>
        <div style="text-align: right; margin-top: 20px;">
          <a-button style="margin-right: 8px;" @click="centerDialog.isShow = false">取消</a-button>
          <a-button type="primary" @click="centerDialogClick(centerDialog.clickBind)">确认</a-button>
        </div>
      </a-modal>
    </div>
  </a-layout-sider>
</template>

<script lang="ts">
import { defineComponent, ref, computed, watch } from 'vue';
import axios from 'axios';
import { openLoading, fullscreenLoading } from '@/utils/loadingUtils';
import { message, notification } from 'ant-design-vue';
import { useRoute, useRouter } from 'vue-router';
import { mapState, useStore } from 'vuex';
import {
  DashboardOutlined, TeamOutlined, UserOutlined,
  AppstoreOutlined, CodeOutlined, GiftOutlined, ThunderboltOutlined,
  SearchOutlined, LogoutOutlined, WalletOutlined, KeyOutlined, BankOutlined,
} from '@ant-design/icons-vue';

const baseURL = process.env.VUE_APP_API_BASE_URL;

export default defineComponent({
  name: 'NavigationBar',
  components: {
    DashboardOutlined, TeamOutlined, UserOutlined,
    AppstoreOutlined, CodeOutlined, GiftOutlined, ThunderboltOutlined,
    SearchOutlined, LogoutOutlined, WalletOutlined, KeyOutlined, BankOutlined,
  },
  computed: {
    ...mapState(['isCollapse']),
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const isCollapsed = computed(() => store.getters.isCollapse == 0 || store.getters.isCollapse == -1);
    const logoFailed = ref<boolean>(false);

    const defaultActive = computed(() => route.path);

    // 路径 → 所属 sub-menu key 的映射
    const pathToOpenKey = (path: string): string[] => {
      if (['/console', '/userLog'].includes(path)) return ['1'];
      if (['/develop', '/productManage', '/VersionLog', '/NoticeManage', '/DataManage'].includes(path)) return ['6'];
      if (['/CarmineList', '/CarmineUse'].includes(path)) return ['7'];
      return [];
    };

    const openKeys = ref<string[]>(pathToOpenKey(route.path));

    // 监听路由变化，自动展开所属父菜单（但不强制关闭用户手动展开的其他菜单）
    watch(() => route.path, (newPath) => {
      const needed = pathToOpenKey(newPath);
      needed.forEach((k) => {
        if (!openKeys.value.includes(k)) openKeys.value = [...openKeys.value, k];
      });
    }, { immediate: true });

    const onOpenKeysChange = (keys: string[]) => { openKeys.value = keys; };

    const navigateTo = (path: string) => {
      store.dispatch('setIsCollapse', store.getters.isCollapse);
      router.push(path);
    };

    const user_conf = ref(JSON.parse(localStorage.getItem('user_conf') || '{}'));

    const outLogin = () => {
      localStorage.removeItem('token');
      message.success('退出登录成功');
      setTimeout(() => { location.reload(); }, 1000);
    };

    const centerDialog = ref({ isShow: false, title: '提示', content: '', clickBind: '' });

    const openDialog = (title: string, content: string, isShow: boolean, clickBind: string) => {
      if (!isShow) {
        centerDialog.value.isShow = false;
      } else {
        centerDialog.value.title = title;
        centerDialog.value.content = content;
        centerDialog.value.isShow = true;
        centerDialog.value.clickBind = clickBind;
      }
    };

    const centerDialogClick = (act: string) => {
      if (act === 'outLogin') outLogin();
    };

    const isLogin = () => {
      openLoading();
      axios.get(baseURL + '/userApi/isLogin', { timeout: 5000, headers: { token: localStorage.getItem('token') } })
        .then((res) => {
          fullscreenLoading.close();
          if (res.data.code == -1) {
            message.error('您没有登录');
            setTimeout(() => { location.href = '/Login'; }, 1000);
          }
          if (res.data.code == 0 && res.data.isDefault == true) {
            notification.info({ message: '信息', description: '您的密码为默认的123456，为保证安全请尽快修改', duration: 0 });
          }
        })
        .catch((err) => { fullscreenLoading.close(); message.error('请求失败：' + err.message); });
    };

    return {
      navigateTo, isLogin, centerDialogClick, openDialog, centerDialog,
      outLogin, store, isCollapsed, logoFailed, openKeys, onOpenKeysChange,
      user_conf, defaultActive,
    };
  },
});
</script>

<style scoped lang="scss">
.side-sider {
  background: #001529 !important;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15);
  overflow: hidden;
}

.side-inner {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #001529;
}

.side-logo {
  height: 56px;
  min-height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  background: rgba(255, 255, 255, 0.03);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  gap: 10px;
  cursor: pointer;

  .logo-img {
    height: 24px;
    width: auto;
    transition: all 0.2s;

    &.collapsed {
      display: none;
    }
  }

  .logo-text {
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 1px;
    white-space: nowrap;
    background: linear-gradient(135deg, #fff 0%, #a6adf9 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}

.side-menu {
  flex: 1;
  border-right: none !important;
  background: #001529 !important;
  padding: 8px 0;
  // overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.15);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.3);
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  :deep(.ant-menu-item),
  :deep(.ant-menu-submenu-title) {
    margin: 4px 8px !important;
    border-radius: 6px !important;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.75);
    transition: all 0.2s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.08) !important;
      color: #fff !important;
    }
  }

  :deep(.ant-menu-item-selected) {
    background: #1677ff !important;
    color: #fff !important;
    box-shadow: 0 2px 8px rgba(22, 119, 255, 0.4);
  }

  :deep(.ant-menu-divider) {
    margin: 12px 16px;
    border-color: rgba(255, 255, 255, 0.08);
  }

  :deep(.ant-menu-submenu-open .ant-menu-submenu-title) {
    background: rgba(255, 255, 255, 0.06) !important;
    color: #fff !important;
  }
}
</style>
